import { AnyObject } from '@store/types';
import uniq from 'lodash/uniq';

export function getEnumValues<E = string>(sourceEnum: Record<string, E>, isSameKeyValue: boolean = false): E[] {
    const values = Object.values(sourceEnum);
    return isSameKeyValue
        ? uniq(values)
        : values.filter(item => {
              const isEnumKey = (item as AnyObject)[0] === (item as AnyObject)[0].toUpperCase();
              return !isEnumKey;
          });
}
